export default __webpack_public_path__ + "static/media/male_combed_backwards.2c58c175.png";